import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const updateSingleCancelledNonProcessed = async (unitId: string): Promise<boolean> =>
  axios.post(`/management/unit/UpdateSingleCancelledNonProcessed?unitId=${unitId}`).then((res) => res?.data?.result)

export const useManagementUpdateSingleCancelledNonProcessed = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['updateSingleCancelledNonProcessed'],
    mutationFn: ({ unitId }: { unitId: string }) => updateSingleCancelledNonProcessed(unitId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated non processed.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update non processed.')
      }
    },
    throwOnError: false
  })
